import { forwardRef } from 'react';
import type { SVGIconProps } from '../types';

/**
 * Microsoft 公式ブランドロゴ（フルカラーの 4 分割スクエア）。色は公式配色で固定し `color` は無視する。
 * @see https://learn.microsoft.com/ja-jp/entra/identity-platform/howto-add-branding-in-apps
 */
export const MicrosoftIcon = forwardRef<SVGSVGElement, SVGIconProps>(({
  size = 16,
  color: _color,
  ...props
}, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#F25022" d="M1 1h9v9H1z" />
      <path fill="#7FBA00" d="M11 1h9v9h-9z" />
      <path fill="#00A4EF" d="M1 11h9v9H1z" />
      <path fill="#FFB900" d="M11 11h9v9h-9z" />
    </svg>);
MicrosoftIcon.displayName = 'MicrosoftIcon';